import { Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';

const Constants = {
  h: 98,
  text: {
    x: 100,
  },
  icon: {
    x: 30,
    size: 40,
  },
};
export class MainMenuItem extends lng.Component {
  static _template() {
    const centerY = Constants.h * 0.5;
    return {
      h: Constants.h,
      Label: {
        mountY: 0.5,
        x: Constants.text.x,
        y: centerY + 4,
        w: w => w - Constants.text.x,
        text: {
          ...Theme.Fonts.Normal,
        },
        color: Theme.Colors.Menu.Normal,
      },
      Icon: {
        mountY: 0.5,
        x: Constants.icon.x,
        y: centerY,
        w: Constants.icon.size,
        h: Constants.icon.size,
        color: Theme.Colors.Menu.Normal,
      },
      FocusLine: {
        y: Constants.h - 30,
        h: 4,
        w: 30,
        x: Constants.text.x,
        color: Theme.Colors.Primary,
        alpha: 0,
        rect: true,
      },
    };
  }

  _init() {
    this._isActive = false;
  }

  set active(val) {
    if (this._isActive !== val) {
      this._isActive = val;
      const col = val ? Theme.Colors.Menu.Active : Theme.Colors.Menu.Normal;
      this.tag('Icon').setSmooth('color', col);
      this.tag('Label').setSmooth('color', col);
    }
  }

  get active() {
    return this._isActive;
  }

  set label(value) {
    this.tag('Label').text.text = value;
  }

  set icon(value) {
    this.tag('Icon').src = value;
  }

  expand() {
    this.tag('Label').setSmooth('alpha', 1);
  }

  collapse() {
    this.tag('Label').setSmooth('alpha', 0);
  }

  _focus() {
    this.tag('FocusLine').setSmooth('alpha', 1);
    // this.tag('Icon').setSmooth('color', Theme.Colors.Menu.Active);
    this.tag('Label').setSmooth('color', Theme.Colors.Menu.Active);
  }

  _unfocus() {
    this.tag('FocusLine').setSmooth('alpha', 0);
    if (!this._isActive) {
      // this.tag('Icon').setSmooth('color', Theme.Colors.Menu.Normal);
      this.tag('Label').setSmooth('color', Theme.Colors.Menu.Normal);
    }
  }

  _handleEnter() {
    this.signal('onActivate', this);
  }
}
